(function () {
  function observeFeatures(scope) {
    const root = scope || document;
    const feats = root.querySelectorAll('.kava-pdp-root .feat .f');
    if (!feats.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      feats.forEach((f) => f.classList.add('in-view'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    feats.forEach((f) => io.observe(f));
  }

  function bindShopAnchors(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-kava-shop]').forEach((btn) => {
      if (btn.dataset.bound === 'true') return;
      btn.dataset.bound = 'true';
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const target = document.getElementById('shop-section');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initStickyBar() {
    const bar = document.getElementById('kavaStickyBar');
    if (!bar || bar.dataset.kavaStickyInit === 'true') return;

    const triggerId = bar.dataset.kavaStickyTrigger || 'kava-usp-hero';
    const trigger = document.getElementById(triggerId);
    if (!trigger) return;

    bar.dataset.kavaStickyInit = 'true';
    bar.hidden = false;

    const syncPrice = () => {
      const cta = document.getElementById('mixersCtaBtn');
      const priceEl = bar.querySelector('[data-kava-sticky-price]');
      if (!cta || !priceEl) return;
      const m = (cta.textContent || '').match(/—\s*(.+)$/);
      if (m) priceEl.textContent = m[1].trim();
    };

    const updateVisibility = () => {
      const rect = trigger.getBoundingClientRect();
      const reached = rect.top < window.innerHeight - 80;
      bar.classList.toggle('show', reached);
      if (reached) syncPrice();
    };

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);
    updateVisibility();

    const cta = document.getElementById('mixersCtaBtn');
    if (cta && 'MutationObserver' in window) {
      new MutationObserver(syncPrice).observe(cta, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    bar.querySelector('[data-kava-sticky-atc]')?.addEventListener('click', () => {
      document.getElementById('mixersCtaBtn')?.click();
    });
  }

  function boot(scope) {
    observeFeatures(scope);
    bindShopAnchors(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      boot();
      initStickyBar();
    });
  } else {
    boot();
    initStickyBar();
  }

  document.addEventListener('shopify:section:load', (e) => {
    boot(e.target);
    if (e.target.querySelector?.('#kavaStickyBar') || e.target.id === 'kava-usp-hero') {
      initStickyBar();
    }
  });
})();
